<template>
  <div>
    <el-upload
      class="xuexin-uploader"
      drag
      :action="uploadUrl"
      :before-upload="handleBeforeUpload"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :headers="headers"
      :show-file-list="false"
      :on-remove="handleRemove"
    >
     <img v-if="fileList.length > 0" :src="fileList[0].fullPath" class="avatar" />
     <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
  </div>
</template>
<script>
import { getToken } from "@/plugins/auth";
export default {
  props: {
    linkfileList: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 1
    },
    fileType: {
      type: String,
      default: ""
    },
    btnSize: {
      type: String,
      default: "small"
    },
    buttonTxt: {
      type: String,
      default: "上传文件"
    }
  },
  data() {
    return {
      type: this.fileType,
      uploadUrl: process.env.VUE_APP_BASE_API + "/file/upload",
      headers: {
        Authorization: "Bearer " + getToken()
      },
      fileList: []
      // fileType: "DOC,DOCX,XLS,XLSX,PPT,PDF,TXT,JPG,JPEG,PNG,BMP,GIF"
    };
  },
  watch: {
    linkfileList: {
      immediate: true,
      handler() {
        this.fileList = this.linkfileList;
      }
    },
    fileType: {
      handler(newValue, oldValue) {
        this.type = newValue;
      },
      deep: true
    }
  },
  methods: {
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      if (this.type) {
        let typeList = this.type.split(",");
        return this.beforeUpload(file, typeList,this.type);
      }
      if (file.name.length > 50) {
        this.$message.error("文件名长度不能超过50个字");
        return false;
      }
      
      return true;
    },
    // 文件个数超出
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制只能上传 ${this.limit} 个文件`);
    },
    getFile() {
      this.$emit("getFile", this.fileList);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error("上传失败, 请重试");
    },
    // 上传成功回调
    handleUploadSuccess(res, file, fileList) {
      this.$message.success("上传成功");
      this.fileList = []
      this.fileList.push({ name: res.data.name, url: res.data.url , fullPath: process.env.VUE_APP_FILE_API + res.data.url });
      this.$emit("clearValidate");
      this.$emit("getFile", this.fileList);
    },
    handleRemove(file, fileList) {
      this.fileList = this.fileList.filter(item => item.uid !== file.uid);
    },
    cleanList() {
        this.fileList = []
        this.$emit("clearValidate");
    }
  }
};
</script>
<style scoped>
.el-upload-dragger {
    width: 300px;
    height: 200px;
}
.el-upload-dragger .el-icon-upload {
    line-height: 40px;
    height: 40px;
    margin: 20px 0 0 0;
}
.uploadIcon {
  display: flex;
  flex-flow: column;
  justify-content: center;
}
/* .el-upload {
    display: block;
} */
.xuexin-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    /* width: 308px; */
    width: auto;
    height: 180px;
    margin: 0 auto;
    display: block;
}
</style>